import { render, staticRenderFns } from "./TopNavigationB.vue?vue&type=template&id=f2e17164&scoped=true"
import script from "./TopNavigationB.vue?vue&type=script&lang=js"
export * from "./TopNavigationB.vue?vue&type=script&lang=js"
import style0 from "./TopNavigationB.vue?vue&type=style&index=0&id=f2e17164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e17164",
  null
  
)

export default component.exports